(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/lodash/isObject.js
  var require_isObject = __commonJS({
    "node_modules/lodash/isObject.js"(exports, module) {
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      module.exports = isObject;
    }
  });

  // node_modules/lodash/_freeGlobal.js
  var require_freeGlobal = __commonJS({
    "node_modules/lodash/_freeGlobal.js"(exports, module) {
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      module.exports = freeGlobal;
    }
  });

  // node_modules/lodash/_root.js
  var require_root = __commonJS({
    "node_modules/lodash/_root.js"(exports, module) {
      var freeGlobal = require_freeGlobal();
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      module.exports = root;
    }
  });

  // node_modules/lodash/now.js
  var require_now = __commonJS({
    "node_modules/lodash/now.js"(exports, module) {
      var root = require_root();
      var now = function() {
        return root.Date.now();
      };
      module.exports = now;
    }
  });

  // node_modules/lodash/_trimmedEndIndex.js
  var require_trimmedEndIndex = __commonJS({
    "node_modules/lodash/_trimmedEndIndex.js"(exports, module) {
      var reWhitespace = /\s/;
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {
        }
        return index;
      }
      module.exports = trimmedEndIndex;
    }
  });

  // node_modules/lodash/_baseTrim.js
  var require_baseTrim = __commonJS({
    "node_modules/lodash/_baseTrim.js"(exports, module) {
      var trimmedEndIndex = require_trimmedEndIndex();
      var reTrimStart = /^\s+/;
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      module.exports = baseTrim;
    }
  });

  // node_modules/lodash/_Symbol.js
  var require_Symbol = __commonJS({
    "node_modules/lodash/_Symbol.js"(exports, module) {
      var root = require_root();
      var Symbol2 = root.Symbol;
      module.exports = Symbol2;
    }
  });

  // node_modules/lodash/_getRawTag.js
  var require_getRawTag = __commonJS({
    "node_modules/lodash/_getRawTag.js"(exports, module) {
      var Symbol2 = require_Symbol();
      var objectProto = Object.prototype;
      var hasOwnProperty = objectProto.hasOwnProperty;
      var nativeObjectToString = objectProto.toString;
      var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = void 0;
          var unmasked = true;
        } catch (e) {
        }
        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }
      module.exports = getRawTag;
    }
  });

  // node_modules/lodash/_objectToString.js
  var require_objectToString = __commonJS({
    "node_modules/lodash/_objectToString.js"(exports, module) {
      var objectProto = Object.prototype;
      var nativeObjectToString = objectProto.toString;
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      module.exports = objectToString;
    }
  });

  // node_modules/lodash/_baseGetTag.js
  var require_baseGetTag = __commonJS({
    "node_modules/lodash/_baseGetTag.js"(exports, module) {
      var Symbol2 = require_Symbol();
      var getRawTag = require_getRawTag();
      var objectToString = require_objectToString();
      var nullTag = "[object Null]";
      var undefinedTag = "[object Undefined]";
      var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
      function baseGetTag(value) {
        if (value == null) {
          return value === void 0 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }
      module.exports = baseGetTag;
    }
  });

  // node_modules/lodash/isObjectLike.js
  var require_isObjectLike = __commonJS({
    "node_modules/lodash/isObjectLike.js"(exports, module) {
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      module.exports = isObjectLike;
    }
  });

  // node_modules/lodash/isSymbol.js
  var require_isSymbol = __commonJS({
    "node_modules/lodash/isSymbol.js"(exports, module) {
      var baseGetTag = require_baseGetTag();
      var isObjectLike = require_isObjectLike();
      var symbolTag = "[object Symbol]";
      function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      module.exports = isSymbol;
    }
  });

  // node_modules/lodash/toNumber.js
  var require_toNumber = __commonJS({
    "node_modules/lodash/toNumber.js"(exports, module) {
      var baseTrim = require_baseTrim();
      var isObject = require_isObject();
      var isSymbol = require_isSymbol();
      var NAN = 0 / 0;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsOctal = /^0o[0-7]+$/i;
      var freeParseInt = parseInt;
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      module.exports = toNumber;
    }
  });

  // node_modules/lodash/debounce.js
  var require_debounce = __commonJS({
    "node_modules/lodash/debounce.js"(exports, module) {
      var isObject = require_isObject();
      var now = require_now();
      var toNumber = require_toNumber();
      var FUNC_ERROR_TEXT = "Expected a function";
      var nativeMax = Math.max;
      var nativeMin = Math.min;
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = void 0;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout(timerExpired, wait);
          return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = void 0;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = void 0;
          return result;
        }
        function cancel() {
          if (timerId !== void 0) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = void 0;
        }
        function flush() {
          return timerId === void 0 ? result : trailingEdge(now());
        }
        function debounced() {
          var time = now(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === void 0) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === void 0) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      module.exports = debounce;
    }
  });

  // node_modules/lodash/throttle.js
  var require_throttle = __commonJS({
    "node_modules/lodash/throttle.js"(exports, module) {
      var debounce = require_debounce();
      var isObject = require_isObject();
      var FUNC_ERROR_TEXT = "Expected a function";
      function throttle2(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        if (isObject(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      module.exports = throttle2;
    }
  });

  // js/modules/controller.js
  var import_throttle = __toESM(require_throttle());
  var errorText = (funcName) => `You need to define your own ${funcName}() method or pass ${funcName} = false to controller constructor`;
  var Controller = class {
    constructor({ ready = false, loaded = false, resized = false, scrolled = false, keypress = false, click = false } = {}) {
      this.init();
      if (ready === true) {
        document.addEventListener("DOMContentLoaded", () => this.ready());
      }
      if (loaded === true) {
        window.addEventListener("load", () => this.loaded());
      }
      if (resized === true) {
        window.addEventListener("resize", (0, import_throttle.default)(() => this.resized(), 100));
      }
      if (scrolled === true) {
        window.addEventListener("scroll", (0, import_throttle.default)(() => this.scrolled(), 100));
      }
      if (keypress === true) {
        window.addEventListener("keydown", () => this.keypress);
      }
      if (click === true) {
        document.addEventListener("click", this.click);
      }
    }
    init() {
    }
    ready() {
      console.log(errorText("ready"));
    }
    loaded() {
      console.log(errorText("loaded"));
    }
    resized() {
      console.log(errorText("resized"));
    }
    scrolled() {
      console.log(errorText("scrolled"));
    }
    keypress() {
      console.log(errorText("keypress"));
    }
    click() {
      console.log(errorText("click"));
    }
  };

  // js/product-stick.js
  var ProductStick = class extends Controller {
    constructor() {
      super({ ready: true, scrolled: true });
      this.handleStickClick = this.handleStickClick.bind(this);
      this.updateChatPosition = this.updateChatPosition.bind(this);
      this.isOneTimePurchaseSelected = false;
      this.animationFrameRequest = null;
    }
    ready() {
      localStorage.removeItem("selectedOptionValue");
      this.setupInitialSelectOption();
      this.updateStickLabel();
      this.setupClickHandler();
      this.toggleModalWindow();
      this.setupResizeHandler();
      this.setupStickClickHandler();
    }
    scrolled() {
      this.handleScroll();
    }
    resized() {
      this.updateChatPosition();
    }
    handleScroll() {
      if (this.animationFrameRequest) {
        cancelAnimationFrame(this.animationFrameRequest);
      }
      this.animationFrameRequest = requestAnimationFrame(() => {
        const accordionItems = document.querySelectorAll(".accordion-item__panel");
        const skincareContentTopElement = accordionItems.length > 1 ? accordionItems[1] : null;
        const sectionStik = document.querySelector(".stick");
        const footer = document.querySelector(".footer");
        if (skincareContentTopElement && sectionStik && footer) {
          const skincareContentTop = skincareContentTopElement.offsetTop - 460;
          const footerTop = footer.offsetTop;
          if (window.scrollY >= skincareContentTop - window.innerHeight && window.scrollY < footerTop - window.innerHeight) {
            sectionStik.classList.add("fixed");
          } else {
            sectionStik.classList.remove("fixed");
          }
        }
        this.updateChatPosition();
      });
    }
    updateStickLabel() {
      const selectedPlanGroup = document.querySelector(".loop-selected-selling-plan-group");
      if (selectedPlanGroup) {
        const subscriptionLabel = selectedPlanGroup.querySelector("label");
        const subscriptionPrice = selectedPlanGroup.querySelector(".price");
        const stickLabel = document.querySelector(".stick__current-variant-label");
        const stickPrice = document.querySelector(".stick__current-variant-price");
        const stickButton = document.querySelector(".stick__button");
        if (subscriptionLabel && stickLabel) {
          stickLabel.textContent = subscriptionLabel.textContent;
        }
        if (subscriptionPrice && stickPrice) {
          stickPrice.innerHTML = "";
          stickPrice.appendChild(subscriptionPrice.cloneNode(true));
        }
        if (stickButton && !stickButton.dataset.clickHandlerSet) {
          stickButton.addEventListener("click", this.handleClickBound);
          stickButton.addEventListener("click", this.handleStickButtonClick);
          stickButton.dataset.clickHandlerSet = "true";
        }
      }
      setTimeout(() => {
        let variantId = document.querySelector(".loop-selling-plan-fieldset");
        let currentVariantId = variantId.getAttribute("data-selected-variant-id");
        if (currentVariantId) {
          const chipsText = document.getElementById(`loop-product-variant-${currentVariantId}`).querySelector(".chips__text div");
          const chipsTextStick = document.querySelector(".stick .chips__text");
          const chipsStick = document.querySelector(".stick .chips");
          if (chipsText && chipsTextStick) {
            setTimeout(() => {
              chipsTextStick.textContent = chipsText.textContent;
              chipsStick.style.opacity = "1";
            }, 150);
          }
        }
      }, 2e3);
      this.updateStickActivity();
    }
    setupStickClickHandler() {
      const stickContainer = document.querySelector(".stick");
      if (stickContainer) {
        stickContainer.addEventListener("click", this.handleStickClick);
      }
    }
    updateStickActivity() {
      const oneTimePurchaseOption = document.querySelector(".loop-one-time-purchase-option");
      const stickOneTime = document.querySelector(".stick__one-time");
      const subscriptionGroup = document.querySelector(".loop-subscription-group");
      const stickSubscribe = document.querySelector(".stick__subscribe");
      const handleOneTimeClick = () => {
        if (oneTimePurchaseOption) {
          oneTimePurchaseOption.click();
        }
      };
      const handleSubscribeClick = () => {
        if (subscriptionGroup) {
          subscriptionGroup.click();
        }
      };
      if (oneTimePurchaseOption && stickOneTime) {
        stickOneTime.removeEventListener("click", handleOneTimeClick);
        if (oneTimePurchaseOption.classList.contains("loop-selected-selling-plan-group")) {
          stickOneTime.classList.add("is-active");
        } else {
          stickOneTime.classList.remove("is-active");
        }
        stickOneTime.addEventListener("click", handleOneTimeClick);
      }
      if (subscriptionGroup && stickSubscribe) {
        stickSubscribe.removeEventListener("click", handleSubscribeClick);
        if (subscriptionGroup.classList.contains("loop-selected-selling-plan-group")) {
          stickSubscribe.classList.add("is-active");
        } else {
          stickSubscribe.classList.remove("is-active");
        }
        stickSubscribe.addEventListener("click", handleSubscribeClick);
      }
    }
    handleStickClick(event) {
      const target = event.target;
      if (target.closest(".stick__one-time")) {
        this.handleOneTimeClick();
      } else if (target.closest(".stick__subscribe")) {
        this.handleSubscriptionClick();
      }
    }
    handleOneTimeClick() {
      const oneTimePurchaseOption = document.querySelector(".loop-one-time-purchase-option");
      if (oneTimePurchaseOption) {
        oneTimePurchaseOption.click();
        this.isOneTimePurchaseSelected = true;
        this.updateStickLabel();
        this.applySavedOrDefaultSelection();
      }
    }
    handleSubscriptionClick() {
      const subscriptionGroup = document.querySelector(".loop-subscription-group");
      if (subscriptionGroup) {
        subscriptionGroup.click();
        this.isOneTimePurchaseSelected = false;
        this.applySavedOrDefaultSelection();
        this.updateStickLabel();
      }
    }
    toggleModalWindow() {
      const modalBackdrop = document.querySelector(".stick__button-toggle");
      const modalBackdropButton = document.querySelector(".button-show-form");
      const infoContent = document.querySelector(".stick__info");
      const mainContent = document.querySelector(".stick__content");
      const subscriptionContainer = document.querySelector(".stick__subscription-container");
      const currentVariantPrice = document.querySelector(".stick__current-variant-price");
      const currentVariantLabel = document.querySelector(".stick__current-variant-label");
      const notificationForm = document.querySelector(".stick .notification-form");
      if (modalBackdrop && infoContent) {
        const showModalWindow = (event) => {
          event.preventDefault();
          modalBackdrop.classList.toggle("is-active");
          infoContent.classList.toggle("visible");
          if (subscriptionContainer) subscriptionContainer.classList.toggle("visible");
          if (currentVariantLabel) currentVariantLabel.classList.toggle("visible");
          if (currentVariantPrice) currentVariantPrice.classList.toggle("visible");
          if (mainContent) mainContent.classList.toggle("visible");
          if (notificationForm) notificationForm.classList.toggle("visible");
          this.updateChatPosition();
        };
        if (modalBackdropButton && !modalBackdropButton.dataset.clickHandlerSet) {
          modalBackdropButton.addEventListener("click", showModalWindow);
          modalBackdropButton.dataset.clickHandlerSet = "true";
        }
        if (!modalBackdrop.dataset.clickHandlerSet) {
          modalBackdrop.addEventListener("click", showModalWindow);
          modalBackdrop.dataset.clickHandlerSet = "true";
        }
      }
    }
    setupInitialSelectOption() {
      const selectElement = document.querySelector(".loop-selling-plan-selector");
      if (selectElement) {
        this.applySavedOrDefaultSelection();
        selectElement.removeEventListener("change", this.handleSelectChange);
        selectElement.addEventListener("change", this.handleSelectChange.bind(this));
      }
    }
    handleSelectChange(event) {
      const selectElement = event.currentTarget;
      if (!this.isOneTimePurchaseSelected) {
        localStorage.setItem("selectedOptionValue", selectElement.value);
      }
    }
    applySavedOrDefaultSelection() {
      const selectElement = document.querySelector(".loop-selling-plan-selector");
      if (selectElement) {
        const savedValue = localStorage.getItem("selectedOptionValue");
        const options = selectElement.querySelectorAll("option");
        if (this.isOneTimePurchaseSelected) {
          selectElement.value = options[0].value;
        } else if (savedValue && !this.isOneTimePurchaseSelected) {
          selectElement.value = savedValue;
        } else if (!savedValue && options.length > 1) {
          selectElement.value = options[1].value;
          localStorage.setItem("selectedOptionValue", options[1].value);
        }
        selectElement.dispatchEvent(new Event("change"));
      }
    }
    setupClickHandler() {
      const productForm = document.querySelector(".product-form");
      if (productForm) {
        productForm.removeEventListener("click", this.updateStickLabel);
        productForm.addEventListener("click", () => {
          this.updateStickLabel();
          this.applySavedOrDefaultSelection();
        });
      }
    }
    handleStickButtonClick() {
      const cartSubmitButton = document.querySelector(".product-form__cart-submit.button.button_theme_dark");
      if (cartSubmitButton) {
        cartSubmitButton.click();
      }
    }
    setupResizeHandler() {
      const modalToggleButton = document.querySelector(".stick__button-toggle");
      if (modalToggleButton && !modalToggleButton.dataset.clickHandlerSet) {
        modalToggleButton.addEventListener("click", this.updateChatPosition);
        modalToggleButton.dataset.clickHandlerSet = "true";
      }
    }
    updateChatPosition() {
      const sectionStik = document.querySelector(".stick");
      const chatElement = document.querySelector('inbox-online-store-chat[is-open="false"].needsclick');
      if (sectionStik && chatElement) {
        if (window.innerWidth > 1024 || !sectionStik.classList.contains("fixed")) {
          chatElement.style.setProperty("bottom", "40px", "important");
        } else {
          const stickHeight = sectionStik.offsetHeight;
          chatElement.style.setProperty("bottom", `${stickHeight + 16}px`, "important");
        }
      }
    }
  };
  window.ProductStick = new ProductStick();
})();
